import type { LigneResultat as Ligne } from "@sfs/contracts";
import { joindre, villeDepartement } from "@shared/lib/format";

type Props = { ligne: Ligne; selectionne: boolean; onSelection: () => void; onOuvrir: () => void };

export function LigneResultat({ ligne, selectionne, onSelection, onOuvrir }: Props) {
  return (
    <article className={`res ${ligne.perimee ? "perime" : ""}`} data-seg={ligne.segment}>
      <input type="checkbox" checked={selectionne} onChange={onSelection}
             aria-label={`Sélectionner ${ligne.raisonSociale}`} />
      <div>
        {ligne.perimee && (
          <div className="avert">
            ⚠ Fiche périmée — analysée il y a {ligne.joursDepuisScrape} jours, les constats ont pu changer
          </div>
        )}
        <h3>{ligne.raisonSociale}</h3>
        <div className="sous">
          {joindre(ligne.libelleNaf, villeDepartement(ligne.ville, ligne.departement), ligne.effectifTranche, ligne.statut)}
        </div>
        {ligne.offreN1 && <div className="offre">{ligne.offreN1}</div>}
      </div>
      <div className="act">
        <div className="sc">{ligne.score ?? "—"}</div>
        <span className={`seg ${ligne.segment}`}>{ligne.segment}</span>
        <button className="btn sm" onClick={onOuvrir}>{ligne.perimee ? "Rafraîchir" : "Ouvrir"}</button>
      </div>
    </article>
  );
}
